<template>
  <carousel
    :per-page="1"
    :paginationEnabled="false"
    :mouse-drag="false"
    :autoplay="true"
    :loop="true"
  >
    <slide>
      <img
        src="../assets/images/weekly-logo-icon.png"
        class="eventImg"
        @click="handleSlideClick('week')"
      />
    </slide>
    <slide>
      <img
        src="../assets/images/monthly-logo-icon.png"
        class="eventImg"
        @click="handleSlideClick('month')"
      />
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
export default {
  name: 'slidingTab',
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      // viewerProductList: null
    }
  },
  methods: {
    handleSlideClick(weekMonth) {
      this.$emit('weekMonthHandle', weekMonth)
    }
    // whatsClosemodel() {
    //   $('.whatconttentbox').modal('hide')
    //   //   this.whatsNewmodelOpen = false
    // }
  },
  sockets: {}
}
</script>
